// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.weRNt0muGQ7boUJifIpT {
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: stretch;
  gap: var(--space-xs);
  background-color: var(--white-color);
  border: solid 2px var(--primary-color);
  border-radius: 5em;
  padding: var(--space-s) var(--space-l);
  max-width: 64rem;
  transition: var(--global-nav-transition);
  cursor: pointer;
  margin: var(--space-l) auto;
  margin-bottom: 0;
}

#q5_AYWuNHG7D0ixZPYS7 .weRNt0muGQ7boUJifIpT {
  margin: var(--space-l) auto;
}

.weRNt0muGQ7boUJifIpT:hover,
.weRNt0muGQ7boUJifIpT:focus-within {
  background-color: var(--input-bg-color-hover);
}

.weRNt0muGQ7boUJifIpT:focus-within {
  box-shadow: var(--focus-visible-box-shadow);
}

.weRNt0muGQ7boUJifIpT:hover
  [class*="fa-"]:not(.cGZUNCHTQf_hk7_Z7Akw, .N41S1_zPieuCXBZtke5C, .liXNviU8tVYdyumwgTdF),
.weRNt0muGQ7boUJifIpT:focus-within
  [class*="fa-"]:not(.cGZUNCHTQf_hk7_Z7Akw, .N41S1_zPieuCXBZtke5C, .liXNviU8tVYdyumwgTdF) {
  color: var(--accent-alt-color);
}

.weRNt0muGQ7boUJifIpT:hover ::placeholder,
.weRNt0muGQ7boUJifIpT:focus-within ::placeholder {
  color: rgba(var(--accent-alt-color-rgb), 0.4);
}

.Mymh3w83YEbm8YskTD7Q {
  position: relative;
  flex: 1 1 340px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  gap: var(--space-xs);
}

.Mymh3w83YEbm8YskTD7Q
  [class*="fa-"]:not(.cGZUNCHTQf_hk7_Z7Akw, .N41S1_zPieuCXBZtke5C, .liXNviU8tVYdyumwgTdF) {
  font-size: var(--step-2);
  color: var(--md-grey-color);
  opacity: 0.6;
  transition: var(--global-nav-transition);
}

.rl4z9b0Ujrk_Djbf5CCJ {
  padding-right: 2rem;
  justify-content: flex-end;
  display: flex;
}

.lPhXoDsvc11q1gdtsNu7 {
  width: 50%;
  padding-left: 2rem;
  justify-content: flex-start;
  display: flex;
}
`, "",{"version":3,"sources":["webpack://./src/pages/HomePage/components/HomeSearchBar/HomeSearchBar.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,8BAA8B;EAC9B,oBAAoB;EACpB,oBAAoB;EACpB,oCAAoC;EACpC,sCAAsC;EACtC,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;EAChB,wCAAwC;EACxC,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,6CAA6C;AAC/C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;;;;EAIE,8BAA8B;AAChC;;AAEA;;EAEE,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;EAEE,wBAAwB;EACxB,2BAA2B;EAC3B,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;AACf","sourcesContent":[".searchBarContainer {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: stretch;\n  gap: var(--space-xs);\n  background-color: var(--white-color);\n  border: solid 2px var(--primary-color);\n  border-radius: 5em;\n  padding: var(--space-s) var(--space-l);\n  max-width: 64rem;\n  transition: var(--global-nav-transition);\n  cursor: pointer;\n  margin: var(--space-l) auto;\n  margin-bottom: 0;\n}\n\n#home-body .searchBarContainer {\n  margin: var(--space-l) auto;\n}\n\n.searchBarContainer:hover,\n.searchBarContainer:focus-within {\n  background-color: var(--input-bg-color-hover);\n}\n\n.searchBarContainer:focus-within {\n  box-shadow: var(--focus-visible-box-shadow);\n}\n\n.searchBarContainer:hover\n  [class*=\"fa-\"]:not(.locateButton, .mapButton, .inputClearButton),\n.searchBarContainer:focus-within\n  [class*=\"fa-\"]:not(.locateButton, .mapButton, .inputClearButton) {\n  color: var(--accent-alt-color);\n}\n\n.searchBarContainer:hover ::placeholder,\n.searchBarContainer:focus-within ::placeholder {\n  color: rgba(var(--accent-alt-color-rgb), 0.4);\n}\n\n.inputContainer {\n  position: relative;\n  flex: 1 1 340px;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: center;\n  gap: var(--space-xs);\n}\n\n.inputContainer\n  [class*=\"fa-\"]:not(.locateButton, .mapButton, .inputClearButton) {\n  font-size: var(--step-2);\n  color: var(--md-grey-color);\n  opacity: 0.6;\n  transition: var(--global-nav-transition);\n}\n\n.subNavWrapper {\n  padding-right: 2rem;\n  justify-content: flex-end;\n  display: flex;\n}\n\n.suggestionBoxWrapper {\n  width: 50%;\n  padding-left: 2rem;\n  justify-content: flex-start;\n  display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchBarContainer": `weRNt0muGQ7boUJifIpT`,
	"home-body": `q5_AYWuNHG7D0ixZPYS7`,
	"locateButton": `cGZUNCHTQf_hk7_Z7Akw`,
	"mapButton": `N41S1_zPieuCXBZtke5C`,
	"inputClearButton": `liXNviU8tVYdyumwgTdF`,
	"inputContainer": `Mymh3w83YEbm8YskTD7Q`,
	"subNavWrapper": `rl4z9b0Ujrk_Djbf5CCJ`,
	"suggestionBoxWrapper": `lPhXoDsvc11q1gdtsNu7`
};
export default ___CSS_LOADER_EXPORT___;
